// external
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';

// models, types
import { AmazonFreshItem } from '@/interfaces/Amazon';
import { CallToActionPosition } from '@/interfaces/CallToActionTypes';
import { IPromotion } from '@/interfaces/Promotion';
import { IShoppingListCategory } from '@/interfaces/ShoppingList';
import { Partner } from '@/interfaces/Partner';
import { VuexAction } from '@/@types/index.d';

// store
import {
	GET_SHOPPING_LIST,
	GET_VISIBLE_PROMOTIONS,
	GET_THIRD_TAB_CLICK_REPORT,
	SEND_REPORT,
	GET_FOOTER_BUTTON_CLICKED_REPORT,
} from '@/store/types';
import { IReport } from '@/interfaces/IReport';

@Component({})
export default class AmazonFresh extends Vue {
	@Prop({ required: true }) label!: string;

	@Prop({ required: true }) position!: CallToActionPosition;

	@Getter(GET_SHOPPING_LIST) getShoppingList!: IShoppingListCategory[];

	@Getter(GET_VISIBLE_PROMOTIONS) getVisiblePromotions!: IPromotion[];

	@Getter(GET_THIRD_TAB_CLICK_REPORT) getThirdTabClickReport!: IReport;

	@Getter(GET_FOOTER_BUTTON_CLICKED_REPORT)
	getFooterButtonClickedReport!: IReport;

	@Action(SEND_REPORT) sendReport!: VuexAction<IReport>;

	get amazonShoppingList(): string {
		if (!this.getShoppingList) {
			return '';
		}
		const recipeIngredients = this.getShoppingList
			.map((category) =>
				category.items.map(
					(item) => new AmazonFreshItem(item.name, item.name)
				)
			)
			.reduce((pv, cv) => pv.concat(cv), []);

		const promotionIngredients = this.getVisiblePromotions.map(
			(p) => new AmazonFreshItem(p.productName, p.productName)
		);

		return JSON.stringify({
			ingredients: promotionIngredients.concat(recipeIngredients),
		});
	}

	handleClick() {
		const report = this.getThirdTabClickReport;
		report.mxrThirdTabButtonClicked!.button = {
			label: this.label,
			partner: Partner.AMAZON_FRESH,
		};
		this.sendReport(report);
		this.sendReport(this.getFooterButtonClickedReport);
	}
}
